module.exports = __webpack_public_path__ + "static/media/finnese-core.9389a209.png";